import React from 'react';

/** Tiny SVG line chart for daily spend. Split out of AdminPage.tsx (god-file ratchet, PRP-MCP-7). */
const Sparkline: React.FC<{ values: number[] }> = ({ values }) => {
  if (!values || values.length === 0) {
    return <span className="text-xs text-muted-foreground">—</span>;
  }
  const max = Math.max(0.0001, ...values);
  const w = 100;
  const h = 22;
  const step = values.length > 1 ? w / (values.length - 1) : w;
  const points = values
    .map((v, i) => `${i * step},${h - (v / max) * h}`)
    .join(' ');
  return (
    <svg viewBox={`0 0 ${w} ${h}`} width={w} height={h} className="text-primary">
      <polyline
        points={points}
        fill="none"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinejoin="round"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default Sparkline;
